import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {TypeOptions} from "react-toastify";

type ApiProps = {
    message: string,
    toastType: TypeOptions
} | null

interface SettingsState {
    apiError: ApiProps,
    apiSuccess: ApiProps,
    blockCalculationViaSiteTitle: boolean,
    blockChangeJourneyDuration: boolean,
}

const initialState: SettingsState = {
    apiError: null,
    apiSuccess: null,
    blockCalculationViaSiteTitle: false,
    blockChangeJourneyDuration: false,
}

export const settingsSlice = createSlice({
    name: 'journey',
    initialState,
    reducers: {
        setApiError: (state, action: PayloadAction<SettingsState["apiError"]>) => {
            state.apiError = action.payload
        },
        setApiSuccess: (state, action: PayloadAction<SettingsState["apiSuccess"]>) => {
            state.apiSuccess = action.payload
        },
        blockRecalculationFromSiteTitle: (state, action: PayloadAction<boolean>) => {
            state.blockCalculationViaSiteTitle = action.payload
        },
        blockChangeJourneyDuration: (state, action: PayloadAction<boolean>) => {
            state.blockChangeJourneyDuration = action.payload
        },
        resetApiProps: (state, action: PayloadAction<"error" | "success">) => {
            const {payload} = action
            if (payload === "error") {
                state.apiError = null
            } else {
                state.apiSuccess = null
            }
        }
    }
})

export const {
    resetApiProps,
    setApiError,
    setApiSuccess,
    blockRecalculationFromSiteTitle,
    blockChangeJourneyDuration
} = settingsSlice.actions;
export default settingsSlice.reducer;